import { getCurrentInstance } from 'vue';

/**
 * Tiny vue-gtag wrapper for `<script setup>` components, where `this.$gtag`
 * is unavailable. Must be called during component setup.
 */
export function useGtag() {
  const instance = getCurrentInstance();

  function event(name: string, params?: Record<string, unknown>) {
    try {
      instance?.proxy?.$gtag?.event?.(name, params);
    } catch {
      // Telemetry must never break the app.
    }
  }

  return { event };
}
